import React, {
  useReducer,
  useContext,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { CusButton } from "../../Components/From/Button";
import { CusCheckbox } from "../../Components/From/Checkbox";
import { FormattedMessage } from "react-intl";
import { Global } from "../../App";
import { AsyncModel, AsyncModelClose } from "../AsyncModel/AsyncModel";
import ReactLoading from "react-loading";
import Tool_mealList from "../../Components/Tools/Tool_mealList";
import Tool_otherNeedList from "../../Components/Tools/Tool_otherNeedList";
import Tool_CusOtherNeed from "../../Components/Tools/Tool_CusOtherNeed";
import Tool_CusOtherNeed_error from "../../Components/Tools/Tool_CusOtherNeed";
import Tool_extraNeedLIst from "../Tools/Tool_extraNeedLIst";
import Tool_needStaffCheck from "../Tools/Tool_needStaffCheck";

import _ from "lodash";
import "../../Pages/pages.scss";
// switch lang
import { langStringToCode } from "../../Share/Tools/switchLang";
// api
import { getBranchProduct } from "../../Api/GetProduct";
import {
  postTranslationOrder,
  postCreateOrder,
  postCreateAddOrder,
  GetTempOrderDetail,
  saveTempOrder,
} from "../../Api/GetOrder";
import Tool_storeName from "../Tools/Tool_storeName";
import ErrorContext from "../../Contexts/Error";

import calcTotal from "../../Share/Tools/calcTotal";

import { TimeOutSet, TimeOutRemove } from "../../Share/Tools/Share";

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case "UPDATE_STATE":
      payload.forEach((i) => {
        newState[i.key] = i.val;
      });
      return newState;
    case "UPDATE_CHECK_TERMS":
      newState.isCheckTerms = !newState.isCheckTerms;
      return newState;
    default:
      return newState;
  }
};
let Time;

function OrderStep_4(props) {
  const [btnState, changeBtnStates] = useState(false);
  const { globalState, dispatchGlobal } = useContext(Global);
  const { onError } = useContext(ErrorContext);
  const [state, dispatch] = useReducer(reducer, {
    takeout: [],
    dineIn: [],
    mealList: null,
    isCheckTerms: false,
    needPopupSetting: {
      toggle: false,
      needName: "",
      subArray: [],
      needId: null,
    },
    extraDataList: [],
    extraDataAnsList: [],
  });
  const [refreshPage, setRefreshPage] = useState(false);
  const [tempToggle, setTempToggle] = useState(false);
  const [isExtraCheck, setIsExtraCheck] = useState(false);
  const [isOrderDisable, setIsOrderDisable] = useState(false);
  const [isSentOrder, setIsSentOrder] = useState(false);
  const [isExtraError, setIsExtraError] = useState(false);
  const extraNeedListRef = useRef(null);
  const [isNeedStaffCheckModel, setIsNeedStaffCheckModel] = useState(false);
  const [needStaffCheckID, setneedStaffCheckID] = useState(0);

  // 區隔takeout & dineIn
  function splitDineType(data) {
    data = _.cloneDeep(data);
    // 外帶
    let takeout = data.reduce((currProduct, itemProduct) => {
      itemProduct = {
        ...itemProduct,
        specification: itemProduct.specification.reduce(
          (currSpec, itemSpec) => {
            // 只取特性為[外帶]的組合
            itemSpec = {
              ...itemSpec,
              combination: itemSpec.combination.filter((f) => f.takeout),
            };
            // 此組合都沒有[外帶]特性時
            if (itemSpec.combination.length <= 0) {
              // 找出此組合在此的index標號
              // let findIndex = itemProduct.specification.findIndex(f=>f.id === itemSpec.id)
              // 刪除此規格下index標號的規格
              // itemProduct.specification.splice(findIndex, 1);
              return [...currSpec];
            } else {
              return [...currSpec, itemSpec];
            }
          },
          []
        ),
      };
      if (itemProduct.specification.length <= 0) {
        return [...currProduct];
      } else {
        return [...currProduct, itemProduct];
      }
    }, []);
    // 內用
    // console.log(data);
    let dineIn = data.reduce((currProduct, itemProduct) => {
      itemProduct = {
        ...itemProduct,
        specification: itemProduct.specification.reduce(
          (currSpec, itemSpec) => {
            // 只取特性為[內用]的組合
            itemSpec = {
              ...itemSpec,
              combination: itemSpec.combination.filter((f) => !f.takeout),
            };
            // console.log(itemSpec.combination);
            // 此組合都沒有[內用]特性時
            // console.log(itemSpec);
            if (itemSpec.combination.length <= 0) {
              // 找出此組合在此的index標號
              // let findIndex = itemProduct.specification.findIndex(f=>f.id === itemSpec.id)
              // 刪除此規格下index標號的規格
              // itemProduct.specification.splice(findIndex, 1);
              return [...currSpec];
            } else {
              return [...currSpec, itemSpec];
            }
          },
          []
        ),
      };
      if (itemProduct.specification.length <= 0) {
        return [...currProduct];
      } else {
        return [...currProduct, itemProduct];
      }
    }, []);
    // console.log('takeout', takeout);
    // console.log('dineIn', dineIn);
    return { takeout: takeout, dineIn: dineIn };
  }
  // 計算餐點數量&總金額(餐點單價*數量 + 特口價格*數量)
  const handleTotalPrice = useMemo(() => {
    const takeoutTotals = calcTotal(state.takeout);
    const dineInTotals = calcTotal(state.dineIn);
    const totalQuantity = state.takeout.length + state.dineIn.length;
    return {
      totalMealQuantity: totalQuantity,
      dineInTotalPrice: dineInTotals.total,
      dineInSpecPrice: dineInTotals.tasteTotal,
      takeoutInTotalPrice: takeoutTotals.total,
      takeoutInSpecPrice: takeoutTotals.tasteTotal,
    };
  }, [state.dineIn, state.takeout]);
  // 四捨五入至小數點第n位
  const formatNumber = (value, pos) => {
    const float = Math.pow(10, pos);
    return (Math.round(value * float) / float).toFixed(pos);
  };

  // 檢查是否有售畢商品
  function haveSoldOut(mealList) {
    return mealList.find((eachMeal) => {
      return eachMeal.specification.some((eachSpec) => {
        // 狀態是售畢
        return (
          eachSpec.status === 3 &&
          eachSpec.combination.some((eachCombi) => {
            // 且數量不為零
            return eachCombi.quantity > 0;
          })
        );
      });
    });
  }

  // 處理要回傳的資料格式
  function handlePostOrder(data) {
    let outputFormat = data.map((eachProduct) => ({
      id: eachProduct.id,
      specification: eachProduct.specification.map((eachSpec) => ({
        id: eachSpec.id,
        status: eachSpec.status,
        combination: eachSpec.combination.map((eachCombi) => ({
          ...eachCombi,
        })),
      })),
    }));
    // 照id排序
    outputFormat.sort((a, b) => {
      return a.id > b.id ? 1 : -1;
    });
    return outputFormat;
  }
  // 取得該店全部餐點
  async function apiAllProduct(langId, storeId) {
    const backToStep3 = () => {
      dispatchGlobal({
        type: "UPDATE",
        payload: [
          {
            key: "customer",
            val: {
              ...globalState.customer,
              currentStep: "3",
              currentQrStep: "1",
            },
          },
        ],
      });
    };
    try {
      const waittingAlert = AsyncModel({
        content: (
          <div className="w-100 d-flex justify-content-center">
            <ReactLoading
              type="spokes"
              color="#ccc"
              height="100px"
              width="100px"
            />
          </div>
        ),
        showConfirmBtn: false,
      });
      const res = await getBranchProduct(langId, storeId);
      AsyncModelClose();
      const { errCode, productList } = res.data;
      if (errCode == 200) {
        // 餐點總攬
        let _mealList = productList.map((e) => {
          let type = e.id;
          let typeName = e.name;
          let newArr = e.product.map((_product) => ({
            type: type,
            typeName: typeName,
            title: _product.name,
            description: _product.description,
            ..._product,
          }));
          return newArr;
        });
        _mealList = _.flatten(_mealList);
        dispatch({
          type: "UPDATE_STATE",
          payload: [{ key: "mealList", val: _mealList }],
        });
      } else {
        const Alert = await AsyncModel({
          title: globalState.langFile[`errorMsg.errorCode_${errCode}`],
          confirmBtnText: globalState.langFile["popup.buttonConfirm"],
        });
        if (Alert) return backToStep3();
      }
    } catch {
      console.error("AllProduct error.");
      const Alert = await AsyncModel({
        title: globalState.langFile[`errorMsg.errorCode_${407}`],
        confirmBtnText: globalState.langFile["popup.buttonConfirm"],
      });
      if (Alert) return backToStep3();
    }
  }
  async function apiGetTempOrderDetail(
    tempOrderGroupID,
    languageID,
    storeID,
    createAt,
    tableNo
  ) {
    let res;
    try {
      res = await GetTempOrderDetail(
        tempOrderGroupID,
        languageID,
        storeID,
        createAt,
        tableNo
      );
    } catch (err) {
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 405 }],
      });
      props.history.push("/error");
    }

    let { errCode } = res.data;
    if (res && (errCode === 200 || errCode === 414)) {
      return res.data;
    } else {
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: errCode }],
      });
      props.history.push("/error");
    }
  }

  async function GetTempOrder(tempOrderGroupID) {
    const res = await apiGetTempOrderDetail(
      tempOrderGroupID,
      langStringToCode(globalState.langType),
      globalState.customer.orderInfo.selectedBranch.branchCode,
      moment().format("YYYY/MM/DD"),
      globalState.customer.orderInfo.tableNo
    );
    if (res.errCode === 414) {
      TimeOutRemove();
      const Alert = await AsyncModel({
        title: globalState.langFile[`pages.takeOrder.AddOrderMsg`],
        confirmBtnText:
          globalState.langFile["pages.takeOrder.step5.buttonDetail"],
      });
      //AsyncModelClose();

      if (Alert) {
        props.history.push(
          `/showOrderDetail?orderCode=${
            globalState.customer.orderInfo.mainOrderCode
          }&storeID=${String(
            globalState.customer.orderInfo.selectedBranch.branchCode
          )}&createAt=${moment().format("YYYY/MM/DD")}`
        );
      }
    } else {
      let { dineIn, takeout } = res.productList;
      let deepCopy = [];
      dineIn.map((e) => {
        let productIndex = deepCopy.findIndex((f) => f.id === e.id);
        if (productIndex > -1) {
          const Data = e.specification[0];
          deepCopy[productIndex].specification.push(Data);
        } else {
          deepCopy.push(e);
        }
      });

      takeout.map((e) => {
        let productIndex = deepCopy.findIndex((f) => f.id === e.id);
        if (productIndex > -1) {
          console.log(e.id, e.specification);
          e.specification.map((x) => {
            let deepData = deepCopy[productIndex].specification.filter((e) => {
              return e.id === x.id;
            });
            if (deepData.length > 0) {
              //console.log("deepData", deepData[0].combination)
              // console.log("Data.combination", Data.combination)
              x.combination.map((y) => {
                deepData[0].combination.push(y);
              });
            } else {
              deepCopy[productIndex].specification.push(x);
            }
          });
          //const Data = e.specification[0];

          deepCopy[productIndex].takeoutTaste = e.takeoutTaste;
        } else {
          deepCopy.push(e);
        }
      });

      TimeOutSet(OrderTemp);
      return deepCopy;
    }
  }
  const OrderTemp = async () => {
    const deepCopy = await GetTempOrder(
      globalState.customer.orderInfo.tempOrderGroupID
    );
    const { mealOrderDetail } = globalState.customer;
    await dispatchGlobal({
      type: "UPDATE",
      payload: [
        {
          key: "customer",
          val: {
            ...globalState.customer,
            mealDetail: "",
            mealOrderDetail: deepCopy,
            orderDetail: {
              totalMealQuantity: mealOrderDetail.length,
              ...handleTotalPrice,
            },
          },
        },
      ],
    });
  };

  // 翻譯訂單資訊
  async function apiTranslateOrder() {
    const backToStep3 = () => {
      dispatchGlobal({
        type: "UPDATE",
        payload: [
          {
            key: "customer",
            val: {
              ...globalState.customer,
              currentStep: "3",
              currentQrStep: "1",
            },
          },
          {
            key: "selectedExtra",
            val: {
              selectedExtraQ: {},
              selectedExtraA: [],
            },
          },
        ],
      });
    };
    try {
      let bAdd = false;
      const { orderInfo, mealOrderDetail } = globalState.customer;
      let dineIn;
      let takeout;
      if (globalState.ordermode === "addorder") {
        const result = await apiGetTempOrderDetail(
          orderInfo.tempOrderGroupID,
          langStringToCode(globalState.langType),
          globalState.customer.orderInfo.selectedBranch.branchCode,
          moment().format("YYYY/MM/DD"),
          globalState.customer.orderInfo.tableNo
        );

        if (result.errCode === 200) {
          bAdd = true;
          dineIn = result.productList.dineIn;
          takeout = result.productList.takeout;

          const extraDataList = result.productList.extraDataList;
          console.log("result.productList", result.productList);

          dispatch({
            type: "UPDATE_STATE",
            payload: [
              { key: "takeout", val: takeout },
              { key: "dineIn", val: dineIn },
              { key: "extraDataList", val: extraDataList },
            ],
          });

          //更新附加需求顯示
          let selectedId = null;
          extraDataList.map((item) => {
            item.extraOptionList.map((option) => {
              if (option.selectedMode === 1 && selectedId === null) {
                // Check if selectedId is not already set
                selectedId = option.id; // Set selectedId when a match is found
              }
            });
            return null; // Returning null since you're not using the array generated by map
          });
          setneedStaffCheckID(selectedId);
          await OrderTemp();
        } else if (result.errCode === 414) {
          TimeOutRemove();
          const Alert = await AsyncModel({
            title: globalState.langFile[`pages.takeOrder.AddOrderMsg`],
            confirmBtnText:
              globalState.langFile["pages.takeOrder.step5.buttonDetail"],
          });

          if (Alert) {
            props.history.push(
              `/showOrderDetail?orderCode=${
                globalState.customer.orderInfo.mainOrderCode
              }&storeID=${String(
                globalState.customer.orderInfo.selectedBranch.branchCode
              )}&createAt=${moment().format("YYYY/MM/DD")}`
            );
          }
        }
      } else {
        dineIn = splitDineType(mealOrderDetail).dineIn;
        takeout = splitDineType(mealOrderDetail).takeout;

        const res = await postTranslationOrder({
          queueNumber: orderInfo.queueNumber,
          queueCode: orderInfo.queueCode,
          countryID: orderInfo.country,
          storeID: orderInfo.selectedBranch.branchCode,
          adultsCount: orderInfo.numberOfAdult,
          childCount: orderInfo.numberOfChild,
          languageID: langStringToCode(globalState.langType),
          dineIn: dineIn ? handlePostOrder(dineIn) : [],
          takeout: takeout ? handlePostOrder(takeout) : [],
        });

        const { errCode, translation } = res.data;
        if (errCode == 200) {
          let extraAns = [];
          if (!globalState.selectedExtra) {
            console.log("globalState.selectedExtra 不存在");
          }
          if (translation.extraDataList.length != 0) {
            if (globalState.selectedExtra.selectedExtraA) {
              let questions = translation.extraDataList.map((x) => x.id);
              console.debug(questions);
              extraAns = globalState.selectedExtra.selectedExtraA.filter((x) =>
                questions.includes(x.qusetionId)
              );
            }
          }
          console.debug({ "orderstep_4 selectedExtraA:": extraAns });

          dispatchGlobal({
            type: "UPDATE",
            payload: [
              {
                key: "customer",
                val: {
                  ...globalState.customer,
                  // mealOrderDetail: updateMealOrderDetail(productList),
                  orderDetail: {
                    totalMealQuantity: handleTotalPrice.totalMealQuantity,
                    dineInTotalPrice: handleTotalPrice.dineInTotalPrice,
                    dineInSpecPrice: handleTotalPrice.dineInSpecPrice,
                    takeoutInTotalPrice: handleTotalPrice.takeoutInTotalPrice,
                    takeoutInSpecPrice: handleTotalPrice.takeoutInSpecPrice,
                  },
                  orderInfo: {
                    ...globalState.customer.orderInfo,
                    countryName: translation.countryName,
                    selectedBranch: {
                      ...globalState.customer.orderInfo.selectedBranch,
                      branchName: translation.storeName,
                    },
                  },
                  selectedExtraA: extraAns,
                },
              },
              {
                key: "selectedExtra",
                val: {
                  selectedExtraQ: {},
                  selectedExtraA: extraAns,
                },
              },
            ],
          });
          dispatch({
            type: "UPDATE_STATE",
            payload: [
              { key: "takeout", val: translation.takeout },
              { key: "dineIn", val: translation.dineIn },
              { key: "extraDataList", val: translation.extraDataList },
            ],
          });
        } else {
          const Alert = await AsyncModel({
            title: globalState.langFile[`errorMsg.errorCode_${errCode}`],
            confirmBtnText: globalState.langFile["popup.buttonConfirm"],
          });

          if (Alert) {
            return backToStep3();
          }
        }
      }
      // dispatch({
      //   type: 'UPDATE_STATE',
      //   payload: [
      //     { key: 'takeout', val: takeout },
      //     { key: 'dineIn', val: dineIn }
      //   ]
      // });

      if (bAdd) {
        TimeOutSet(apiTranslateOrder);
        //IntervalAsync();
      }
    } catch (err) {
      console.error(err);
      console.error("TranslateOrder error.");
      const Alert = await AsyncModel({
        title: globalState.langFile[`errorMsg.errorCode_${408}`],
        confirmBtnText: globalState.langFile["popup.buttonConfirm"],
      });

      if (Alert) {
        return backToStep3();
      }
    }
  }
  // 建立訂單
  async function apiCreateOrder() {
    setIsOrderDisable(true);
    try {
      let res;
      const { orderInfo, mealOrderDetail, orderDetail, QRCodeID } =
        globalState.customer;
      const dineIn = splitDineType(mealOrderDetail).dineIn;
      const takeout = splitDineType(mealOrderDetail).takeout;
      const checkDineIn = handlePostOrder(dineIn);
      const orderExtra = getExtraSelected();
      const orderExtraNew = String(checkIsNeedStaff());

      if (globalState.ordermode === "addorder") {
        console.log("orderExtra", orderExtra, "orderExtraNew", orderExtraNew);
        res = await postCreateAddOrder({
          queueNumber: orderInfo.queueNumber,
          queueCode: orderInfo.queueCode,
          countryID: orderInfo.country,
          storeID: orderInfo.selectedBranch.branchCode,
          adultsCount: orderInfo.numberOfAdult,
          childCount: orderInfo.numberOfChild,
          languageID: langStringToCode(globalState.langType),
          userEmail: globalState.customer.emailAddress || "",
          mainOrderCode: globalState.customer.orderInfo.mainOrderCode, //加點模式要傳
          posCode: globalState.customer.orderInfo.posCode, //加點模式要傳
          tableNo: globalState.customer.orderInfo.tableNo, //加點模式要傳
          tempOrderGroupID: globalState.customer.orderInfo.tempOrderGroupID, //加點模式要傳
          dineIn: handlePostOrder(dineIn),
          takeout: handlePostOrder(takeout),
          totalPrice:
            orderDetail.dineInTotalPrice + orderDetail.takeoutInTotalPrice,
          QRCodeID,
          // orderExtraList: [orderExtraNew],
          orderExtraList: globalState.selectedExtra.selectedExtraA,
        });
      } else {
        res = await postCreateOrder({
          queueNumber: orderInfo.queueNumber,
          queueCode: orderInfo.queueCode,
          countryID: orderInfo.country,
          storeID: orderInfo.selectedBranch.branchCode,
          adultsCount: orderInfo.numberOfAdult,
          childCount: orderInfo.numberOfChild,
          languageID: langStringToCode(globalState.langType),
          userEmail: globalState.customer.emailAddress || "",
          dineIn: handlePostOrder(dineIn),
          takeout: handlePostOrder(takeout),
          totalPrice:
            orderDetail.dineInTotalPrice + orderDetail.takeoutInTotalPrice,
          QRCodeID,
          // orderExtraList: orderExtra,
          orderExtraList: globalState.selectedExtra.selectedExtraA,
          startOrderTime: orderInfo.orderTime,
        });
      }

      const { orderCode, errorMessage } = res.data.order;
      const { errCode } = res.data;

      // AsyncModelClose();
      if (errCode === 200) {
        AsyncModel({
          content: (
            <div className="w-100 d-flex justify-content-center">
              <ReactLoading
                type="spokes"
                color="#ccc"
                height="100px"
                width="100px"
              />
            </div>
          ),
          footerMsg: globalState.langFile["pages.takeOrder.loading"],
          showConfirmBtn: false,
        });

        AsyncModelClose();
        TimeOutRemove();

        return orderCode;
      } else {
        // 商品售畢，僅返回前一頁，測報168,錯誤訊息
        if (errCode === 5001) {
          onError({
            errCode,
            errMessage: errorMessage,
            onBack: () => {
              dispatchGlobal({
                type: "UPDATE",
                payload: [
                  {
                    key: "customer",
                    val: {
                      ...globalState.customer,
                      currentStep: "4",
                      currentQrStep: "2",
                    },
                  },
                ],
              });
            },
          });

          TimeOutRemove();
          return;
        }
        if (errCode === 5002) {
          const items = errorMessage.split("%").slice(0);

          await AsyncModel({
            title: globalState.langFile["erroMsg.erroeCode_5002"],
            content: (
              <div className="w-100 flex flex-col px-2 text-center ">
                {items.map((item, index) => (
                  <div className="w-100 border-bottom border-light py-2">
                    {" "}
                    <span key={index}>{item}</span>
                  </div>
                ))}
              </div>
            ),
            showConfirmBtn: true,
          });

          setRefreshPage(!refreshPage);
          TimeOutRemove();

          return;
        }
        if (errCode === 4601) {
          await AsyncModel({
            title: globalState.langFile["errorMsg.errorCode_4601.header"],
            msg: errorMessage,
            content: (
              <div className="w-100 d-flex  justify-content-center">
                <span>
                  {globalState.langFile["errorMsg.errorCode_4601.footer"]}
                </span>
              </div>
            ),
            showConfirmBtn: true,
          });

          setIsExtraCheck(true);
          await scrollToExtraNeedList();
        } else {
          onError({
            errCode,
            errMessage: errorMessage,
            onBack: () => {
              dispatchGlobal({
                type: "RESET",
              });
            },
          });
        }
      }
    } catch (err) {
      console.error("CreateOrder error.");
      onError({
        errCode: 409,
        onBack: () => {
          dispatchGlobal({
            type: "RESET",
          });
        },
      });
    } finally {
      setIsOrderDisable(false);
    }
  }
  async function sentOrder() {
    let getOrderCode = await apiCreateOrder();
    if (getOrderCode) {
      let productList = [];
      globalState.customer.mealOrderDetail.map((eachProduct) => {
        eachProduct.specification.map((eachSpec) => {
          eachSpec.combination.map((eachCombi) => {
            productList.push({
              name: `${eachProduct.name}${
                eachSpec.name ? ` ${eachSpec.name}` : ""
              }`,
              id: String(eachSpec.id),
              price: formatNumber(eachSpec.price, 2),
              category: eachProduct.categoryName,
              variant: eachCombi.takeout ? "Takeout" : "DineIn",
              quantity: eachCombi.quantity,
            });
          });
        });
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "purchase",
        ecommerce: {
          purchase: {
            actionField: {
              id: getOrderCode,
              revenue: formatNumber(
                (handleTotalPrice.dineInSpecPrice +
                  handleTotalPrice.dineInTotalPrice) *
                  1.1 +
                  handleTotalPrice.takeoutInSpecPrice +
                  handleTotalPrice.takeoutInTotalPrice,
                2
              ),
              tax: formatNumber(
                (handleTotalPrice.dineInSpecPrice +
                  handleTotalPrice.dineInTotalPrice) *
                  0.1,
                2
              ),
              step: 3,
            },
            // 'currencyCode': 'NTD',
            products: productList,
          },
        },
      });

      dispatchGlobal({
        type: "UPDATE",
        payload: [
          {
            key: "customer",
            val: {
              ...globalState.customer,
              currentStep: "5",
              currentQrStep: "3",
              orderInfo: {
                ...globalState.customer.orderInfo,
                orderCode: getOrderCode,
              },
            },
          },
        ],
      });
    }
  }
  //
  useEffect(() => {
    let langCode = langStringToCode(globalState.langType);
    let storeCode = globalState.customer.orderInfo.selectedBranch.branchCode;

    apiAllProduct(langCode, storeCode);
    apiTranslateOrder();
  }, [globalState.langType]);

  //useEffect(() => {
  //  async function handler() {
  //    apiTranslateOrder();
  //    //TimeOutSet(apiTranslateOrder, 3000);
  //  }
  //  handler();
  //}, [globalState.langType, refreshPage]);

  //useEffect(() =>{
  //  TimeOutSet(apiTranslateOrder);
  //});

  //const IntervalAsync = () => {
  //  TimeOutSet(apiTranslateOrder, 3000);
  //};

  // 取消選擇整個附加條件題目
  async function removeExtraSelected(removeExtraIDs) {
    //讀global的
    const updatedExtraDataList =
      globalState.customer.orderInfo.extraDataList.filter(
        (item) => item.extraId !== removeExtraIDs
      );

    dispatchGlobal({
      type: "UPDATE",
      payload: [
        {
          key: "customer",
          val: {
            ...globalState.customer,
            orderInfo: {
              ...globalState.customer.orderInfo,
              extraDataList: updatedExtraDataList,
            },
          },
        },
      ],
    });
    const updateDelete = updatedExtraDataList.flatMap(
      (item) => item.selectedItemIDs
    );
  }
  // 加點取消選擇整個附加條件題目
  async function removeAddOrderExtraSelected(removeExtraIDs) {
    //加點從api的回傳打資料
    const previousSelected = state.extraDataList
      .flatMap((group) => {
        const selectedItems = group.extraOptionList.filter(
          (item) => item.selectedMode === 1
        );
        if (selectedItems.length > 0) {
          return {
            extraId: group.id,
            selectedItemIDs: selectedItems.map((item) => item.id),
          };
        }
        return null;
      })
      .filter(Boolean);

    const updatedExtraDataList = previousSelected.filter(
      (item) => item.extraId !== removeExtraIDs
    );
    //讀global的
    // const updatedExtraDataList =
    //   globalState.customer.orderInfo.extraDataList.filter(
    //     (item) => item.extraId !== removeExtraIDs
    //   );

    dispatchGlobal({
      type: "UPDATE",
      payload: [
        {
          key: "customer",
          val: {
            ...globalState.customer,
            orderInfo: {
              ...globalState.customer.orderInfo,
              extraDataList: updatedExtraDataList,
            },
          },
        },
      ],
    });
    const updateDelete = updatedExtraDataList.flatMap(
      (item) => item.selectedItemIDs
    );

    // 為了加點要再跑一次
    const { mealOrderDetail } = globalState.customer;
    const dineIn = splitDineType(mealOrderDetail).dineIn;
    const takeout = splitDineType(mealOrderDetail).takeout;

    if (globalState.ordermode === "addorder") {
      const mainOrderCode = globalState.customer.orderInfo.mainOrderCode;

      try {
        await saveTempOrder({
          isNew: false,
          queueNumber: globalState.customer.orderInfo.queueNumber,
          queueCode: globalState.customer.orderInfo.queueCode,
          countryID: globalState.customer.orderInfo.country,
          storeID: globalState.customer.orderInfo.selectedBranch.branchCode,
          adultsCount: globalState.customer.orderInfo.numberOfAdult,
          childCount: globalState.customer.orderInfo.numberOfChild,
          userEmail: null,
          totalPrice: 0,
          waiterID: null,
          languageID: 1,
          QRCodeID: null,
          tempOrderID: globalState.customer.orderInfo.tempOrderID,
          tempOrderGroupID: globalState.customer.orderInfo.tempOrderGroupID,
          mainOrderCode: globalState.customer.orderInfo.mainOrderCode, //加點模式要傳
          posCode: globalState.customer.orderInfo.posCode, //加點模式要傳
          tableNo: globalState.customer.orderInfo.tableNo, //加點模式要傳
          dineIn: dineIn,
          takeout: takeout,
          temp: "temp" + globalState.customer.currentStep,
          orderExtraList: updateDelete,
        }).then(() => {
          apiTranslateOrder();
        });
        // dispatch({
        //   type: "UPDATE_STATE",
        //   payload: [
        //     {
        //       key: "extraDataList",
        //       val: updatedExtraDataList,
        //     },
        //   ],
        // });
      } catch (err) {}
    }
  }
  //新 判斷附加需求
  function checkIsNeedStaff() {
    const selectedItem = state.extraDataList.find(
      (menuItem) => menuItem.selected === 1
    );
    if (selectedItem) {
      const selectedExtraOption = selectedItem.extraOptionList.find(
        (extraOption) => extraOption.selectedMode === 1
      );
      return selectedExtraOption ? selectedExtraOption.id : null;
    }
    return null;
  }

  function getExtraSelected() {
    //把附加選項併一併
    if (globalState.customer.orderInfo.extraDataList) {
      const combinedSelectedItems =
        globalState.customer.orderInfo.extraDataList.flatMap(
          (item) => item.selectedItemIDs
        );

      return combinedSelectedItems;
      // console.log("combinedSelectedItems ",combinedSelectedItems)
    }
  }
  // 加點的附加選項
  async function updateAddOrderExtra(orderExtra) {
    const { orderInfo, mealOrderDetail, orderDetail, QRCodeID } =
      globalState.customer;
    const dineIn = splitDineType(mealOrderDetail).dineIn;
    const takeout = splitDineType(mealOrderDetail).takeout;

    await saveTempOrder({
      isNew: false,
      queueNumber: globalState.customer.orderInfo.queueNumber,
      queueCode: globalState.customer.orderInfo.queueCode,
      countryID: globalState.customer.orderInfo.country,
      storeID: globalState.customer.orderInfo.selectedBranch.branchCode,
      adultsCount: globalState.customer.orderInfo.numberOfAdult,
      childCount: globalState.customer.orderInfo.numberOfChild,
      userEmail: null,
      totalPrice: 0,
      waiterID: null,
      languageID: 1,
      QRCodeID: null,
      tempOrderID: globalState.customer.orderInfo.tempOrderID,
      tempOrderGroupID: globalState.customer.orderInfo.tempOrderGroupID,
      mainOrderCode: globalState.customer.orderInfo.mainOrderCode, //加點模式要傳
      posCode: globalState.customer.orderInfo.posCode, //加點模式要傳
      tableNo: globalState.customer.orderInfo.tableNo, //加點模式要傳
      dineIn: dineIn,
      takeout: takeout,
      temp: "temp" + globalState.customer.currentStep,
      orderExtraList: [orderExtra],
    });
  }

  /*
    useEffect(() => {
      apiTranslateOrder();
    }, [state.bUpdate]);
  */
  // Function to scroll to the position of the Tool_extraNeedList
  const scrollToExtraNeedList = async () => {
    if (extraNeedListRef.current) {
      extraNeedListRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  state.otherNeed = [];

  if (!state.mealList) {
    return null;
  }

  return (
    <>
      {globalState.ordermode === "addorder" ? (
        <div className="Pages__section align-items-center pb-sm-4">
          <div className="Pages__title">
            <div className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__action">
              <p className="txtColorBrown font-bold mt-1 mb-1 mt-sm-2 mb-sm-2 text-3xl">
                {globalState.customer.orderInfo.tableNo}
                {globalState.langFile["header.menuItems.tableorder"]}
              </p>
              <span className="pr-2 pl-2 pr-sm-3 pl-sm-3 txtColorBrown">
                {globalState.langFile["header.menuItems.serialnumber"]}
                {globalState.customer.orderInfo.posCode}
              </span>
            </div>
          </div>
        </div>
      ) : null}
      {!globalState.customer.QRCodeID &&
      globalState.ordermode !== "addorder" ? (
        <div className="Pages__space">
          <div className="Pages__space__item  align-items-center p-2 p-sm-3">
            <div className="d-flex align-items-center p-0 col-12 col-sm-4 pt-2 pb-2">
              <span className="mr-2">
                <Tool_storeName
                  storeId={
                    globalState.customer.orderInfo.selectedBranch.branchCode
                  }
                />
                {/* {globalState.customer.orderInfo.selectedBranch.branchName} */}
              </span>
              <span className="mr-2">
                {globalState.customer.orderInfo.numberOfAdult}
                <FormattedMessage id="pages.takeOrder.step4.orderInfo.numberOfAdult" />
              </span>
              <span className="mr-2">
                {globalState.customer.orderInfo.numberOfChild}
                <FormattedMessage id="pages.takeOrder.step4.orderInfo.numberOfChild" />
              </span>
              {/*<span className="mr-2">
                {globalState.customer.orderInfo.countryName}
              </span>*/}
            </div>
            <div className="p-0 col-6 col-sm-4 pt-2 pb-2">
              <FormattedMessage id="pages.takeOrder.step4.orderInfo.queueNumber" />
              <span className="ml-2 txtColorBrown orderInfo">
                {globalState.customer.orderInfo.queueNumber}
              </span>
            </div>
            <div className="p-0 d-flex align-items-center col-8 col-sm-4 pt-2 pb-2">
              <FormattedMessage id="pages.takeOrder.step4.orderInfo.queueCode" />
              <span className="ml-2 txtColorRed orderInfo">
                {globalState.customer.orderInfo.queueCode}
              </span>
            </div>
            <div className="p-0 col-12  pt-2 pb-2">
              <span className="mr-2">
                <FormattedMessage id="pages.takeOrder.step4.orderInfo.time" />
              </span>
              <span className="mr-2">
                {globalState.customer.orderInfo.orderTime}
              </span>
            </div>
          </div>
        </div>
      ) : null}
      {/* 內用列表 */}
      <div className="Pages__section pt-3">
        {state.dineIn.length > 0 ? (
          state.dineIn.map((eachProduct, eachProductIndex) => (
            //<Tool_mealListShowOnly
            //  key={eachProductIndex}
            //  user="customer"
            //  type="dineIn"
            //  data={eachProduct}
            //  onModify={() => {
            //    TimeOutRemove();
            //    let findProduct = state.mealList.find(
            //      (e) => e.id === eachProduct.id
            //    );
            //    dispatchGlobal({
            //      type: "UPDATE",
            //      payload: [
            //        {
            //          key: "customer",
            //          val: {
            //            ...globalState.customer,
            //            currentStep: "3.1",
            //            currentQrStep: "1.1",
            //            isFromOrderDetail: true,
            //            mealDetail: findProduct,
            //          },
            //        },
            //      ],
            //    });
            //  }}
            ///>
            <div
              key={eachProductIndex}
              className={
                eachProductIndex === state.dineIn.length - 1
                  ? ""
                  : "border_under"
              }
            >
              <Tool_mealList
                deleteButton={false}
                modifyButton={true}
                IsShowOrderDetail={false}
                type="dineIn"
                device={globalState.device}
                data={eachProduct}
                onModify={() => {
                  TimeOutRemove();
                  let findProduct = state.mealList.find(
                    (e) => e.id === eachProduct.id
                  );
                  dispatchGlobal({
                    type: "UPDATE",
                    payload: [
                      {
                        key: "customer",
                        val: {
                          ...globalState.customer,
                          currentStep: "3.1",
                          currentQrStep: "1.1",
                          isFromOrderDetail: true,
                          mealDetail: findProduct,
                        },
                      },
                    ],
                  });
                }}
              />
            </div>
          ))
        ) : (
          <div className="mt-3 text-center">
            <FormattedMessage id="pages.takeOrder.step4.dineInNotExist" />
          </div>
        )}
      </div>

      {/* 外帶列表 */}
      <div className="Pages__section">
        {(() => {
          if (state.takeout.length <= 0) return null;
          return (
            <>
              <div className="Pages__space">
                <div className="Pages__specification__title Pages__space__item w-100 d-flex justify-content-center txtColorBrown pt-3 pb-3 mb-3 mt-3">
                  <FormattedMessage id="pages.takeOrder.step4.takeOrder" />
                </div>
              </div>

              {state.takeout.map((eachProduct, eachProductIndex) => (
                <div
                  key={eachProductIndex}
                  className={
                    eachProductIndex === state.takeout.length - 1
                      ? ""
                      : "border_under"
                  }
                >
                  <Tool_mealList
                    deleteButton={false}
                    modifyButton={true}
                    IsShowOrderDetail={false}
                    type="takeout"
                    device={globalState.device}
                    data={eachProduct}
                    onModify={() => {
                      TimeOutRemove();
                      let findProduct = state.mealList.find(
                        (e) => e.id === eachProduct.id
                      );
                      dispatchGlobal({
                        type: "UPDATE",
                        payload: [
                          {
                            key: "customer",
                            val: {
                              ...globalState.customer,
                              currentStep: "3.1",
                              currentQrStep: "1.1",
                              isFromOrderDetail: true,
                              mealDetail: findProduct,
                            },
                          },
                        ],
                      });
                    }}
                  />
                </div>
              ))}
            </>
          );
        })()}
      </div>
      {/* 其他需求 */}
      <div ref={extraNeedListRef}></div>
      {state.extraDataList.length > 0 ? (
        <>
          <div className="Pages__section">
            {(() => {
              // if (state.otherNeed.length <= 0) return null;
              return (
                <>
                  {/* 附加需求大分類標題之後有多個題目再加上去 */}
                  <div className="Pages__space">
                    <div className="Pages__specification__title Pages__space__item w-100 d-flex justify-content-center txtColorBrown pt-3 pb-3 mb-3 mt-3">
                      <p>
                        {" "}
                        <FormattedMessage id="pages.takeOrder.step4.otherNeed" />
                      </p>
                    </div>
                  </div>
                </>
              );
            })()}
          </div>
          {state.extraDataList.map((eachExraNeed, eachExraNeedIndex) => (
            <Tool_extraNeedLIst
              key={eachExraNeedIndex}
              qId={eachExraNeed.id}
              data={eachExraNeed}
              onOpenToggle={(newCurrModify) => {
                dispatch({
                  type: "UPDATE_STATE",
                  payload: [
                    {
                      key: "needPopupSetting",
                      val: newCurrModify,
                    },
                  ],
                });
              }}
              removeExtraSelected={removeExtraSelected}
              removeAddOrderExtraSelected={removeAddOrderExtraSelected}
              isExtraCheck={isExtraCheck}
              setIsExtraCheck={setIsExtraCheck}
              setIsSentOrder={setIsSentOrder}
              setIsNeedStaffCheckModel={setIsNeedStaffCheckModel}
              setselectedExtra={() => {
                if (!globalState.selectedExtra) {
                  console.log("globalState.selectedExtra 不存在");
                  dispatchGlobal({
                    type: "UPDATE",
                    payload: [
                      {
                        key: "selectedExtra",
                        val: {
                          selectedExtraA: [],
                          selectedExtraQ: eachExraNeed,
                        },
                      },
                    ],
                  });
                } else {
                  dispatchGlobal({
                    type: "UPDATE",
                    payload: [
                      {
                        key: "selectedExtra",
                        val: {
                          ...globalState.selectedExtra,
                          selectedExtraQ: eachExraNeed,
                        },
                      },
                    ],
                  });
                }
              }}
              needStaffCheckID={needStaffCheckID}
            />
          ))}
        </>
      ) : (
        ""
      )}
      {/* 價格 */}
      <div className="Pages__section Pages__space mt-2 mt-sm-4 mb-2 mb-sm-4">
        <div className="Pages__space__item">
          {/* 合計 */}
          <div className="d-flex pr-3 pl-3">
            <div className="col-4 col-sm-7"></div>
            <div
              className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3"
              style={{ borderBottom: "1px solid rgba(0,0,0,.1)" }}
            >
              <div className="d-flex justify-content-end align-items-center col-6 p-0 text-right">
                <FormattedMessage id="pages.takeOrder.step4.sum.price" />
              </div>
              <div
                translate="no"
                className="d-flex justify-content-end align-items-center col-6 p-0 orderInfo"
              >
                $
                {formatNumber(
                  handleTotalPrice.dineInSpecPrice +
                    handleTotalPrice.dineInTotalPrice +
                    handleTotalPrice.takeoutInSpecPrice +
                    handleTotalPrice.takeoutInTotalPrice,
                  2
                )}
              </div>
            </div>
          </div>
          {/* 服務費 */}
          <div className="d-flex pr-3 pl-3">
            <div className="col-4 col-sm-7"></div>
            <div
              className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3"
              style={{ borderBottom: "1px solid rgba(0,0,0,.1)" }}
            >
              <div className="d-flex justify-content-end align-items-center col-6 p-0 text-right">
                <FormattedMessage id="pages.takeOrder.step4.sum.tips" />
                (10%)
              </div>
              <div
                translate="no"
                className="d-flex justify-content-end align-items-center col-6 p-0 orderInfo"
              >
                $
                {formatNumber(
                  (handleTotalPrice.dineInSpecPrice +
                    handleTotalPrice.dineInTotalPrice) *
                    0.1,
                  2
                )}
              </div>
            </div>
          </div>
          {/* 總計 */}
          <div className="d-flex pr-3 pl-3">
            <div className="col-4 col-sm-7"></div>
            <div className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3">
              <div className="d-flex justify-content-end align-items-center col-6 p-0 text-right">
                <FormattedMessage id="pages.takeOrder.step4.sum.total" />
              </div>
              <div
                translate="no"
                className="d-flex justify-content-end align-items-center col-6 p-0 txtColorBrown orderInfo"
              >
                $
                {formatNumber(
                  (handleTotalPrice.dineInSpecPrice +
                    handleTotalPrice.dineInTotalPrice) *
                    1.1 +
                    handleTotalPrice.takeoutInSpecPrice +
                    handleTotalPrice.takeoutInTotalPrice,
                  2
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="Pages__section">
        <div className="d-flex justify-content-center align-items-center p-3 txtColorRed text-justify">
          <div className="text-justify">
            {globalState.ordermode === "addorder" ? (
              <p>
                <FormattedMessage id="pages.takeOrder.step4.AddOrdercheckTerms" />
              </p>
            ) : null}
            <FormattedMessage id="pages.takeOrder.step4.checkTerms" />
            <a
              className="link termsOfUse"
              onClick={(event) => {
                event.stopPropagation();
                window.open(`${window.location.href}termsOfUse`, "_blank");
              }}
              children={
                <FormattedMessage id="pages.takeOrder.step4.termsOfUse" />
              }
            />
            <FormattedMessage id="pages.takeOrder.step4.and" />
            <a
              className="link privacyPolicy"
              onClick={(event) => {
                event.stopPropagation();
                window.open(`${window.location.href}privacyPolicy`, "_blank");
              }}
              children={
                <FormattedMessage id="pages.takeOrder.step4.privacyPolicy" />
              }
            />
            <FormattedMessage id="pages.takeOrder.step4.checkTerms2" />
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center p-3">
          <CusCheckbox
            checked={state.isCheckTerms}
            title={
              <span>
                <FormattedMessage id="pages.takeOrder.step4.orderNotice" />
              </span>
            }
            onChange={() => {
              dispatch({
                type: "UPDATE_CHECK_TERMS",
                payload: [{ key: "isCheckTerms" }],
              });
            }}
          />
        </div>
      </div>
      <div className="mt-4 mb-4 d-flex justify-content-center">
        <CusButton.White
          style={{ width: "200px" }}
          className="mt-2 mb-2 mr-3 p-3 col col-sm-auto order-step4-back"
          children={<FormattedMessage id="pages.takeOrder.step4.buttonBack" />}
          onClick={async () => {
            TimeOutRemove();
            dispatchGlobal({
              type: "UPDATE",
              payload: [
                {
                  key: "customer",
                  val: {
                    ...globalState.customer,
                    currentStep: "3",
                    currentQrStep: "1",
                  },
                },
              ],
            });
          }}
        />
        <CusButton.Red
          style={{ width: "200px" }}
          className="mt-2 mb-2 ml-3 p-3 col col-sm-auto order-step4-confirm"
          disabled={
            isOrderDisable ||
            !state.isCheckTerms ||
            (() => {
              const { mealOrderDetail } = globalState.customer;
              const parseDineIn = handlePostOrder(
                splitDineType(mealOrderDetail).dineIn
              );
              const parseTakeout = handlePostOrder(
                splitDineType(mealOrderDetail).takeout
              );
              return (
                (parseDineIn.length <= 0 && parseTakeout.length <= 0) ||
                haveSoldOut(state.dineIn) ||
                haveSoldOut(state.takeout)
              );
            })()
          }
          children={
            <FormattedMessage
              id={(() => {
                const { mealOrderDetail } = globalState.customer;
                const parseDineIn = handlePostOrder(
                  splitDineType(mealOrderDetail).dineIn
                );
                const parseTakeout = handlePostOrder(
                  splitDineType(mealOrderDetail).takeout
                );
                const result =
                  haveSoldOut(state.dineIn) || haveSoldOut(state.takeout)
                    ? "buttonHaveSoldOut"
                    : !state.isCheckTerms ||
                      (parseDineIn.length <= 0 && parseTakeout.length <= 0)
                    ? "buttonDisabled"
                    : "buttonSave";
                return `pages.takeOrder.step4.${result}`;
              })()}
            />
          }
          onClick={async () => {
            if (!globalState.selectedExtra) {
              console.log("globalState.selectedExtra 不存在");
            }
            if (
              !globalState.selectedExtra.selectedExtraA ||
              globalState.selectedExtra.selectedExtraA.length < 0
            ) {
              let first = state.extraDataList.filter(
                (x) => x.selected === 1
              )[0];
              dispatchGlobal({
                type: "UPDATE",
                payload: [
                  {
                    key: "selectedExtra",
                    val: {
                      ...globalState.selectedExtra,
                      selectedExtraQ: first,
                    },
                  },
                ],
              });
              setIsSentOrder(true);
              setIsNeedStaffCheckModel(true);
            } else if (
              state.extraDataList.filter((x) => x.selected === 1).length !==
              globalState.selectedExtra.selectedExtraA.length
            ) {
              let first = state.extraDataList.filter(
                (x) =>
                  x.selected === 1 &&
                  !globalState.selectedExtra.selectedExtraA.some(
                    (y) => y.qusetionId === x.id
                  )
              )[0];
              dispatchGlobal({
                type: "UPDATE",
                payload: [
                  {
                    key: "selectedExtra",
                    val: {
                      ...globalState.selectedExtra,
                      selectedExtraQ: first,
                    },
                  },
                ],
              });
              setIsSentOrder(true);
              setIsNeedStaffCheckModel(true);
            } else {
              await sentOrder();
            }
          }}
        />
      </div>

      {isNeedStaffCheckModel == true ? (
        <Tool_needStaffCheck
          data={globalState.customer.selectedExtraQ}
          allData={state.extraDataList}
          setIsNeedStaffCheckModel={setIsNeedStaffCheckModel}
          needStaffCheckID={needStaffCheckID}
          //setneedStaffCheckID={setneedStaffCheckID}
          setneedStaffCheckID={(ansId) => {
            let ans = globalState.selectedExtra.selectedExtraA;

            if (!ans) {
              ans = [];
            }

            if (ansId !== 0) {
              const ansItem = {
                qusetionId: globalState.selectedExtra.selectedExtraQ.id,
                ansId: ansId,
              };

              if (!ans.some((x) => x.qusetionId === ansItem.qusetionId)) {
                ans.push(ansItem);
              } else {
                if (!ans.some((x) => x.ansId === ansItem.ansId)) {
                  ans = ans.filter((x) => x.qusetionId != ansItem.qusetionId);
                  ans.push(ansItem);
                }
              }
            } else {
              if (
                ans.some(
                  (x) =>
                    x.qusetionId === globalState.selectedExtra.selectedExtraQ.id
                )
              ) {
                ans = ans.filter(
                  (x) =>
                    x.qusetionId !== globalState.selectedExtra.selectedExtraQ.id
                );
              }
            }
            if(!globalState.selectedExtra){
              console.log("globalState.selectedExtra 不存在");
            }

            dispatchGlobal({
              type: "UPDATE",
              payload: [
                {
                  key: "selectedExtra",
                  val: {
                    ...globalState.selectedExtra,
                    selectedExtraA: ans,
                  },
                },
              ],
            });
          }}
          isSentOrder={isSentOrder}
          sentOrder={sentOrder}
          updateAddOrderExtra={updateAddOrderExtra}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default withRouter(OrderStep_4);
